/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const PassSeriesProps = PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    pass_type_ids: PropTypes.arrayOf(PropTypes.string),
    description_body: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            body: PropTypes.string,
        })
    ),
});

export const PassSeriesDefaults = {
    id: null,
    title: '',
    subtitle: '',
    pass_type_ids: [],
    description_body: [],
};
